import { h } from 'vue'
import AtomButton from '~/components/atoms/button/button.vue'
import MoleculeCustomersHubCard from '~/components/molecules/customers-hub-card/customers-hub-card.vue'
import UiComponentContainer from '~ui/components/container/container.vue'
import UiComponentHeading from '~ui/components/heading/heading.vue'
import UiComponentWrapper from '~ui/components/wrapper/wrapper.vue'

const Functional = (props) => {
  const stories = props.record.stories.map(({ isOfTypeExample, ...item }) => ({
    ...item,
    readMore: props.global.readTheirStories,
    type: isOfTypeExample ? 'example-story' : 'classic-story',
  }))

  return h(
    UiComponentContainer,
    {
      class: 'customer-story-section',
    },
    () => [
      h(UiComponentHeading, { level: 2 }, () => props.record.title),
      h(UiComponentWrapper, { class: 'actions' }, () => [
        h(
          AtomButton,
          {
            action: props.primaryButton.action,
            size: 'l',
            to: props.primaryButton.to,
          },
          () => props.primaryButton.slot,
        ),
        h(
          AtomButton,
          {
            action: props.secondaryButton.action,
            onClick: () => props.callback(),
            size: 'l',
            to: props.secondaryButton.to,
            type: 'secondary',
          },
          () => props.secondaryButton.slot,
        ),
      ]),
      h(UiComponentWrapper, { class: 'list' }, () => [
        stories.map(({ id, type: ofType, ...content }) =>
          h(MoleculeCustomersHubCard, {
            key: `item-${id}`,
            content,
            ofType,
          }),
        ),
      ]),
    ],
  )
}

Functional.props = {
  callback: {
    required: true,
    type: Function,
  },
  global: {
    required: true,
    type: Object,
  },
  primaryButton: {
    required: true,
    type: Object,
  },
  record: {
    required: true,
    type: Object,
  },
  secondaryButton: {
    required: true,
    type: Object,
  },
}

export default Functional
